import styled from 'styled-components';
import { Card, Container, Row, Image, Spinner } from 'react-bootstrap';
import { CustomButton, CustomFormik, CustomInput } from 'components/CustomForm';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import InstituteLogo from 'assets/images/institute-logo.png';
import { useMutation } from 'react-query';
import { forgotPassword } from 'network/apis/LoginApi';
import { toast } from 'react-toastify';
import { useContext, useState } from 'react';
import { GlobalContext } from 'context/GlobalContext';
import { getErrorMessage } from "helpers/strings";
import { device } from 'helpers/screen';
import { useNavigate } from 'react-router-dom';
import { ADMIN_USER, COMPANY_USER, PROVINCE_USER } from 'context/GlobalContext';
import CommonLogin from 'components/CommonLogin';
import { MdClose } from "react-icons/md";

const CloseButton = styled.div`
	background-color: #424250;
	width: 2rem;
	height: 2rem;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	position: absolute;
	top: 12px;
	right: 10px;
    cursor: pointer;
`;

const ForgotPasswordPage = () => {
    const { logout } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const forgotMutation = useMutation(forgotPassword, {
        onSuccess: (data) => {
            // handleLogin(data);
            console.log('FORGOT DATA: ', data);
            toast('رمز عبور جدید به شماره همراه ارسال گردید', { type: 'success', position: 'bottom-right' });
            setTimeout(() => logout(), 1000);
        },
        onError: (err) => {
            toast(
                getErrorMessage(err),
                { type: 'error', position: 'bottom-right' }
            );
        },
        onSettled: () => {
            setLoading(false);
        },
    });

    const header = () => (
        <div className='w-100 mb-3'>
            <h3 className='text-center'>فراموشی رمز ورود</h3>
            <CloseButton onClick={() => navigate('/login')}>
                <MdClose color="#fff" />
            </CloseButton>
        </div>
    );

    return (
        <CommonLogin header={header()}>
            <Formik
                initialValues={{ username: '', phone_number: '' }}
                validate={(values) => {
                    const errors = {};
                    if (!values.username) {
                        errors.username = 'ضروری';
                    } else if (!values.phone_number) {
                        errors.password = 'شماره وارد شده معتبر نمی باشد';
                    }
                    return errors;
                }}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    forgotMutation.mutate(values);
                    resetForm();
                }}
            >
                {({ isSubmitting }) => (
                    <CustomFormik>
                        <Field type="text" name="username">
                            {({
                                field,
                                meta: { touched, error }
                            }) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='نام کاربری' />
                            }
                        </Field>
                        <ErrorMessage name="username" component="div" />
                        <Field type="text" name="phone_number">
                            {({
                                field,
                                meta: { touched, error }
                            }) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='شماره تماس' />
                            }
                        </Field>
                        <ErrorMessage name="phone_number" component="div" />
                        <button
                            type="submit"
                            disabled={isSubmitting || loading}
                            className='d-flex align-items-center justify-content-center mt-2 mb-4'
                        >
                            {loading ? (
                                <Spinner animation="border" role="status" size='sm' />
                            ) : (
                                <span>ارسال</span>
                            )}
                        </button>
                    </CustomFormik>
                )}
            </Formik>
        </CommonLogin>
    );
};

export default ForgotPasswordPage;
